import React, { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import TopBar from "../components/TopBar";

const OutLook = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // Check if mobile on mount and window resize
  useEffect(() => {
    const checkMobile = () => {
      const mobile = window.innerWidth < 1024; // lg breakpoint
      setIsMobile(mobile);

      // Auto-close sidebar on mobile
      if (mobile) {
        setIsSidebarOpen(false);
      }
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-neutral-50 via-primary-50/30 to-neutral-50">
      {/* Sidebar */}
      <Sidebar
        isOpen={isSidebarOpen}
        onToggle={toggleSidebar}
        isMobile={isMobile}
      />

      {/* Main Content Wrapper */}
      <div className={`flex flex-col min-h-screen transition-all duration-300 ${isMobile ? '' : isSidebarOpen ? 'pl-72' : 'pl-20'
        }`}>
        {/* TopBar */}
        <TopBar onMenuClick={toggleSidebar} isSidebarOpen={isSidebarOpen} isMobile={isMobile} />

        {/* Main Content Area */}
        <main className="flex-1 mt-16 w-full">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
            <div className="bg-white rounded-xl shadow-sm border border-neutral-200 overflow-hidden">
              <div className="p-6 sm:p-8">
                <Outlet />
              </div>
            </div>

            {/* Footer */}
            <footer className="mt-8 py-6 border-t border-neutral-200">
              <div className="flex flex-col sm:flex-row items-center justify-between text-sm text-neutral-600">
                <span className="text-center sm:text-left">
                  Copyright © {new Date().getFullYear()}.{" "}
                  <a
                    href="https://www.samtec.ng/"
                    target="_blank"
                    rel="noreferrer"
                    className="text-primary-600 hover:text-primary-700 font-medium transition-colors"
                  >
                    Samtec & Associate Nigeria Limited
                  </a>
                </span>
                <span className="mt-2 sm:mt-0 text-neutral-500">
                  Made with <span className="text-danger-500">❤</span> for ATBCOE Kangere
                </span>
              </div>
            </footer>
          </div>
        </main>
      </div>
    </div>
  );
};

export default OutLook;
